/* ============================================================
   KaNi Candy - Produktseite
   Zwei kleine Aufgaben, alle rein oberflaechlich:
     1. die feste Kaufleiste unten ein- und ausblenden,
     2. die Stimmen in der Bewertungskarte durchwechseln.
   Der Kauf selbst laeuft weiter ueber Dawns Formular: die Leiste klickt
   nur dessen Knopf: keine zweite Warenkorb-Logik, die auseinanderlaufen
   koennte.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1. Feste Kaufleiste ---------- */
  function kaufleiste() {
    var leiste = document.querySelector('[data-kani-kaufleiste]');
    if (!leiste) return;

    var knopf = leiste.querySelector('[data-kani-kaufen]');
    var form = document.querySelector('product-info form[data-type="add-to-cart-form"]');
    var echt = form ? form.querySelector('[name="add"]') : null;
    if (!knopf || !echt) { leiste.remove(); return; }

    document.body.classList.add('kani-hat-kaufleiste');

    knopf.addEventListener('click', function () {
      echt.click();
    });

    /* Ausverkauft, ausgewaehlte Variante nicht lieferbar, laufender
       Warenkorb-Aufruf: die Leiste spiegelt den echten Knopf, statt einen
       eigenen Zustand zu fuehren. */
    function spiegle() {
      knopf.disabled = echt.disabled;
      var text = echt.querySelector('span');
      var beschriftung = knopf.querySelector('[data-kani-kaufen-text]');
      if (text && beschriftung && text.textContent.trim()) {
        beschriftung.textContent = text.textContent.trim();
      }
    }
    spiegle();
    if (window.MutationObserver) {
      new MutationObserver(spiegle).observe(echt, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
    }

    /* Sichtbar erst, wenn der grosse Knopf nach OBEN aus dem Bild gescrollt
       ist - nicht schon, solange er weiter unten auf seinen Auftritt wartet.

       Genau das war der Fehler: Beim Oeffnen der Produktseite steht der
       Knopf unterhalb des Sichtfensters, ist also ebenfalls "nicht
       sichtbar". Die alte Bedingung schaute nur darauf und schob die Leiste
       deshalb sofort nach dem Laden herein - noch bevor der Besucher
       ueberhaupt gescrollt hatte. Der Kaufknopf sprang ihn an, statt ihn
       das Produkt ansehen zu lassen.

       boundingClientRect.top unterscheidet die beiden Faelle: oberhalb des
       Fensters ist der Wert negativ, unterhalb positiv. Die Leiste kommt
       also nur, nachdem der Knopf einmal da war und wieder nach oben
       hinausgelaufen ist. */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          var darueberHinaus = e.boundingClientRect.top < 0;
          leiste.classList.toggle('is-da', !e.isIntersecting && darueberHinaus);
        });
      }, { rootMargin: '0px 0px -40px 0px' }).observe(echt);
    }
    /* Ohne IntersectionObserver bleibt die Leiste weg. Frueher wurde sie
       hier dauerhaft eingeblendet - das ist genau das Aufpoppen, das nicht
       sein soll, und der Kaufknopf auf der Seite tut denselben Dienst. */
  }

  /* ---------- 2. Stimmen ---------- */
  function stimmen() {
    var buehne = document.querySelector('[data-kani-stimmen]');
    if (!buehne) return;

    var alle = buehne.querySelectorAll('[data-kani-stimme]');
    if (alle.length < 2) return;

    var wenigerBewegung = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (wenigerBewegung) return;

    var i = 0;
    window.setInterval(function () {
      alle[i].classList.remove('is-da');
      i = (i + 1) % alle.length;
      alle[i].classList.add('is-da');
    }, 6000);
  }

  function los() {
    kaufleiste();
    stimmen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();
